/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BatchSummary } from './BatchSummary';
import {
    BatchSummaryFromJSON,
    BatchSummaryFromJSONTyped,
    BatchSummaryToJSON,
    BatchSummaryToJSONTyped,
} from './BatchSummary';

/**
 * 
 * @export
 * @interface DeleteEmployeePayDetailResponse
 */
export interface DeleteEmployeePayDetailResponse {
    /**
     * 
     * @type {BatchSummary}
     * @memberof DeleteEmployeePayDetailResponse
     */
    data: BatchSummary;
}

/**
 * Check if a given object implements the DeleteEmployeePayDetailResponse interface.
 */
export function instanceOfDeleteEmployeePayDetailResponse(value: object): value is DeleteEmployeePayDetailResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function DeleteEmployeePayDetailResponseFromJSON(json: any): DeleteEmployeePayDetailResponse {
    return DeleteEmployeePayDetailResponseFromJSONTyped(json, false);
}

export function DeleteEmployeePayDetailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteEmployeePayDetailResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': BatchSummaryFromJSON(json['data']),
    };
}

  export function DeleteEmployeePayDetailResponseToJSON(json: any): DeleteEmployeePayDetailResponse {
      return DeleteEmployeePayDetailResponseToJSONTyped(json, false);
  }

  export function DeleteEmployeePayDetailResponseToJSONTyped(value?: DeleteEmployeePayDetailResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': BatchSummaryToJSON(value['data']),
    };
}

